module.exports = __webpack_public_path__ + "img/icwithdraw.3b79185f.png";